<template>
    <div class="o-recruit-memberList">
        <div class="o-recruit-memberList__inner" >
            <Memberitem
                v-for='(item, index) in memberlist'
                :key='index'
                :index='index'
                :id='item.id'
                :memberDada='item'
                :departmentText='departmentText'
                @itemClick="itemClick(item)"
            >
            </Memberitem>
        </div>

        <div class="o-recruit-memberList__modal">
            <modal 
                :state="modal_state"
                :item="modal_item"
                @modalChange="setModalState($state)"
            >
            </modal>
        </div>
    </div>
</template>

<script>
    import Memberitem from './memberitem.vue'
    import modal from './modal.vue'

    export default {
        components: {
            Memberitem,
            modal,
        },
        props:{
            memberlist: Object,
            department: String,
            departmentText: String
        },
        data() {
            return {
                modal_state: false,
                modal_item: {},
            }
        },
        methods: {
            itemClick(item) {
                item.department_text = this.departmentText
                this.setModalItem(item)
                this.setModalState(true)
            },
            setModalItem(item) {
                this.modal_item = item
            },
            setModalState(state){
                this.modal_state = state
            }
        }
    }
</script>
<style scoped>

</style>